import React from 'react';
import { Router, Route, browserHistory } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import ServiceSelector from '../components/ServiceSelector';

function RouterConfig({ history }) {
  return (
    <Router history={history}>
      <LocaleProvider locale={ja_JP}>
        <Route path="/" component={ServiceSelector} />
      </LocaleProvider>
    </Router>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/mobile/config/router.js